import { getGuideDisplayName } from "../../../../../shared/guideNames.js";
import React, { useState, useEffect } from "react";
import { Modal } from "../../../../../components/Modal";
import {
  BTN_GHOST,
  BTN_PRIMARY,
  BUTTON_RESET,
  CARD,
  INPUT,
  LABEL,
  SURFACE,
  SURFACE_BORDER,
} from "../../../../../styles";
import { clone, uuid } from "../../../../../shared/utils";
import {
  fetchSimuladorCursoDetalhes as fetchCursoDetalhes,
  reorderSimuladorModulo as reorderConteudoModulo,
  reorderSimuladorAula as reorderConteudoAula,
} from "../../../../../services/simuladoresConteudoApi";
import { LessonEditor } from "../Lesson";
import { Breadcrumb } from "../../../../../components/BreadCrump";
export function AdminCourseManager(props) {
  let curso = props.curso;
  let categoria = props.categoria;
  let dados = props.dados;
  let setConteudos = props.setConteudos;
  let updateConteudoCurso = props.updateConteudoCurso;
  let removeConteudoCurso = props.removeConteudoCurso;
  let addConteudoModulo = props.addConteudoModulo;
  let updateConteudoModulo = props.updateConteudoModulo;
  let removeConteudoModulo = props.removeConteudoModulo;
  let addConteudoAula = props.addConteudoAula;
  let updateConteudoAula = props.updateConteudoAula;
  let removeConteudoAula = props.removeConteudoAula;
  let showFlash = props.showFlash;
  let onVoltar = props.onVoltar;
  const [editCursoOpen, setEditCursoOpen] = useState(false);
  const [novoModuloOpen, setNovoModuloOpen] = useState(false);
  const [moduloEditando, setModuloEditando] = useState(null);
  const [novaAulaOpen, setNovaAulaOpen] = useState(false);
  const [aulaEditando, setAulaEditando] = useState(null);
  const [loadingDetalhes, setLoadingDetalhes] = useState(false);
  const [cursoForm, setCursoForm] = useState({
    nome: curso.nome,
    sigla: curso.sigla || "",
    descricao: curso.descricao || "",
  });
  const [moduloForm, setModuloForm] = useState({
    nome: "",
    descricao: "",
    minimizado: false,
  });
  const [aulaForm, setAulaForm] = useState({
    titulo: "",
    modulo_id: "",
    videoUrl: "",
  });
  const [moduloDragId, setModuloDragId] = useState(null);
  const [moduloDragOverId, setModuloDragOverId] = useState(null);
  const [aulaDragId, setAulaDragId] = useState(null);
  const [aulaDragOverId, setAulaDragOverId] = useState(null);
  const recarregarDetalhesCurso = async () => {
    const detalhes = await fetchCursoDetalhes(curso.id);
    const moduloIds = new Set(
      detalhes.modulos.map((modulo) => String(modulo.id)),
    );
    setConteudos((prev) => ({
      ...prev,
      modulos: [
        ...(prev.modulos || []).filter(
          (item) => String(item.curso_id) !== String(curso.id),
        ),
        ...detalhes.modulos,
      ],
      aulas: [
        ...(prev.aulas || []).filter(
          (item) => !moduloIds.has(String(item.modulo_id)),
        ),
        ...detalhes.aulas,
      ],
    }));
  };
  useEffect(() => {
    if (
      (dados.modulos || []).some(
        (item) => String(item.curso_id) === String(curso.id),
      )
    )
      return;
    let active = true;
    setLoadingDetalhes(true);
    recarregarDetalhesCurso()
      .catch(() => {
        if (active) {
          showFlash("Erro ao carregar módulos do curso.", "er");
        }
      })
      .finally(() => {
        if (active) {
          setLoadingDetalhes(false);
        }
      });
    return () => {
      active = false;
    };
  }, [curso.id]);
  const parseOrdem = (item) => {
    const ordemNumero = Number(item?.ordem);
    return Number.isFinite(ordemNumero) ? ordemNumero : 0;
  };
  const ordenarAulas = (lista = []) => {
    return [...lista].sort((a, b) => {
      const ordemA = parseOrdem(a);
      const ordemB = parseOrdem(b);
      if (ordemA !== ordemB) return ordemA - ordemB;
      return String(a?.titulo || "").localeCompare(
        String(b?.titulo || ""),
        "pt-BR",
      );
    });
  };
  const reordenarModulosCurso = async (
    moduloOrigemId,
    moduloDestinoId,
    modulosOrdenados,
  ) => {
    if (
      !moduloOrigemId ||
      !moduloDestinoId ||
      moduloOrigemId === moduloDestinoId
    )
      return;
    const origemIndex = modulosOrdenados.findIndex(
      (item) => item.id === moduloOrigemId,
    );
    const destinoIndex = modulosOrdenados.findIndex(
      (item) => item.id === moduloDestinoId,
    );
    if (!(origemIndex < 0 || destinoIndex < 0))
      try {
        await reorderConteudoModulo({
          sourceId: moduloOrigemId,
          targetId: moduloDestinoId,
        });
        const reordenados = [...modulosOrdenados];
        const spliceResult = reordenados.splice(origemIndex, 1);
        const [movido] = spliceResult;
        reordenados.splice(destinoIndex, 0, movido);
        const novaOrdemMap = new Map(
          reordenados.map((reordenado, idx) => [reordenado.id, idx + 1]),
        );
        setConteudos((prev) => ({
          ...prev,
          modulos: prev.modulos.map((modulo) =>
            novaOrdemMap.has(modulo.id)
              ? {
                  ...modulo,
                  ordem: novaOrdemMap.get(modulo.id),
                }
              : modulo,
          ),
        }));
        showFlash("Sequência dos módulos atualizada.");
      } catch (err) {
        showFlash("Erro ao reordenar módulos.", "er");
      }
  };
  const reordenarAulasModulo = async (aulaOrigemId, aulaDestinoId) => {
    if (!aulaOrigemId || !aulaDestinoId || aulaOrigemId === aulaDestinoId)
      return;
    const aulaOrigem = (dados.aulas || []).find(
      (item) => item.id === aulaOrigemId,
    );
    const aulaDestino = (dados.aulas || []).find(
      (item) => item.id === aulaDestinoId,
    );
    if (!aulaOrigem || !aulaDestino) return;
    const mesmoModulo = aulaOrigem.modulo_id === aulaDestino.modulo_id;
    try {
      await reorderConteudoAula({
        sourceId: aulaOrigemId,
        targetId: aulaDestinoId,
      });
      if (mesmoModulo) {
        const aulasOrdenadas = ordenarAulas(
          (dados.aulas || []).filter(
            (item) => item.modulo_id === aulaDestino.modulo_id,
          ),
        );
        const origemIndex = aulasOrdenadas.findIndex(
          (item) => item.id === aulaOrigemId,
        );
        const destinoIndex = aulasOrdenadas.findIndex(
          (item) => item.id === aulaDestinoId,
        );
        if (origemIndex < 0 || destinoIndex < 0) return;
        const reordenados = [...aulasOrdenadas];
        const spliceResult = reordenados.splice(origemIndex, 1);
        const [movida] = spliceResult;
        reordenados.splice(destinoIndex, 0, movida);
        const novaOrdemMap = new Map(
          reordenados.map((reordenado, idx) => [reordenado.id, idx + 1]),
        );
        setConteudos((prev) => ({
          ...prev,
          aulas: prev.aulas.map((aula) =>
            novaOrdemMap.has(aula.id)
              ? {
                  ...aula,
                  ordem: novaOrdemMap.get(aula.id),
                }
              : aula,
          ),
        }));
      } else await recarregarDetalhesCurso();
      showFlash("Sequência das aulas atualizada.");
    } catch (err) {
      showFlash("Erro ao reordenar aulas.", "er");
    }
  };
  const modulos = (dados.modulos || [])
    .filter((item) => String(item.curso_id) === String(curso.id))
    .sort((left, right) => {
      const difference = parseOrdem(left) - parseOrdem(right);
      return (
        difference ||
        String(left?.nome || "").localeCompare(String(right?.nome || ""), "pt-BR")
      );
    });
  return (
    <div
      style={{
        maxWidth: 980,
        margin: "0 auto",
        paddingBottom: 36,
      }}
    >
      {editCursoOpen && (
        <Modal titulo={"Editar curso"} onClose={() => setEditCursoOpen(false)}>
          <div
            style={{
              display: "grid",
              gap: 12,
            }}
          >
            <div>
              <label style={LABEL}>{"Nome"}</label>
              <input
                value={cursoForm.nome}
                onChange={(event) =>
                  setCursoForm((prev) => ({
                    ...prev,
                    nome: event.target.value,
                  }))
                }
                style={INPUT}
              />
            </div>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr",
                gap: 12,
              }}
            >
              <div>
                <label style={LABEL}>{"Descrição"}</label>
                <textarea
                  value={cursoForm.descricao}
                  onChange={(event) =>
                    setCursoForm((prev) => ({
                      ...prev,
                      descricao: event.target.value,
                    }))
                  }
                  style={{
                    ...INPUT,
                    minHeight: 90,
                    resize: "vertical",
                  }}
                />
              </div>
              {null}
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 10,
              marginTop: 16,
            }}
          >
            <button onClick={() => setEditCursoOpen(false)} style={BTN_GHOST}>
              {"Cancelar"}
            </button>
            <button
              onClick={async () => {
                if (cursoForm.nome.trim()) {
                  try {
                    if (updateConteudoCurso) {
                      await updateConteudoCurso(curso.id, {
                        nome: cursoForm.nome.trim(),
                        sigla: curso.sigla,
                        descricao: cursoForm.descricao.trim(),
                      });
                    } else {
                      setConteudos((prev) => ({
                        ...prev,
                        cursos: prev.cursos.map((item) =>
                          item.id === curso.id
                            ? {
                                ...item,
                                nome: cursoForm.nome.trim(),
                                sigla: curso.sigla,
                                descricao: cursoForm.descricao.trim(),
                              }
                            : item,
                        ),
                      }));
                    }
                  } catch (error) {
                    showFlash("Erro ao atualizar curso na API.", "er");
                    return;
                  }
                  setEditCursoOpen(false);
                  showFlash("Curso atualizado.");
                } else showFlash("Nome do curso obrigatorio.", "er");
              }}
              style={BTN_PRIMARY}
            >
              {"Salvar"}
            </button>
          </div>
        </Modal>
      )}
      {novoModuloOpen && (
        <Modal titulo={"Novo modulo"} onClose={() => setNovoModuloOpen(false)}>
          <div
            style={{
              display: "grid",
              gap: 12,
            }}
          >
            <div>
              <label style={LABEL}>{"Nome"}</label>
              <input
                value={moduloForm.nome}
                onChange={(event) =>
                  setModuloForm((prev) => ({
                    ...prev,
                    nome: event.target.value,
                  }))
                }
                style={INPUT}
              />
            </div>
            <div>
              <label style={LABEL}>{"Descrição"}</label>
              <textarea
                value={moduloForm.descricao}
                onChange={(event) =>
                  setModuloForm((prev) => ({
                    ...prev,
                    descricao: event.target.value,
                  }))
                }
                style={{
                  ...INPUT,
                  minHeight: 90,
                  resize: "vertical",
                }}
              />
            </div>
            <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                color: "#334155",
                fontWeight: 700,
                fontSize: 13,
              }}
            >
              <input
                type={"checkbox"}
                checked={moduloForm.minimizado}
                onChange={(event) =>
                  setModuloForm((prev) => ({
                    ...prev,
                    minimizado: event.target.checked,
                  }))
                }
              />
              {"Iniciar recolhido"}
            </label>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 10,
              marginTop: 16,
            }}
          >
            <button onClick={() => setNovoModuloOpen(false)} style={BTN_GHOST}>
              {"Cancelar"}
            </button>
            <button
              onClick={async () => {
                if (moduloForm.nome.trim()) {
                  try {
                    if (addConteudoModulo) {
                      await addConteudoModulo({
                        curso_id: curso.id,
                        nome: moduloForm.nome.trim(),
                        descricao: moduloForm.descricao.trim(),
                        minimizado: moduloForm.minimizado,
                      });
                    } else {
                      setConteudos((prev) => ({
                        ...prev,
                        modulos: [
                          ...prev.modulos,
                          {
                            id: uuid(),
                            curso_id: curso.id,
                            nome: moduloForm.nome.trim(),
                            descricao: moduloForm.descricao.trim(),
                            minimizado: moduloForm.minimizado,
                          },
                        ],
                      }));
                    }
                  } catch (error) {
                    showFlash("Erro ao criar modulo na API.", "er");
                    return;
                  }
                  setNovoModuloOpen(false);
                  setModuloForm({
                    nome: "",
                    descricao: "",
                    minimizado: false,
                  });
                  showFlash("Modulo criado.");
                } else showFlash("Nome do modulo obrigatorio.", "er");
              }}
              style={BTN_PRIMARY}
            >
              {"Criar módulo"}
            </button>
          </div>
        </Modal>
      )}
      {moduloEditando && (
        <Modal
          titulo={"Editar módulo: ".concat(moduloEditando.nome)}
          onClose={() => setModuloEditando(null)}
        >
          <div
            style={{
              display: "grid",
              gap: 12,
            }}
          >
            <div>
              <label style={LABEL}>{"Nome"}</label>
              <input
                value={moduloEditando.nome}
                onChange={(event) =>
                  setModuloEditando((prev) => ({
                    ...prev,
                    nome: event.target.value,
                  }))
                }
                style={INPUT}
              />
            </div>
            <div>
              <label style={LABEL}>{"Descrição"}</label>
              <textarea
                value={moduloEditando.descricao || ""}
                onChange={(event) =>
                  setModuloEditando((prev) => ({
                    ...prev,
                    descricao: event.target.value,
                  }))
                }
                style={{
                  ...INPUT,
                  minHeight: 90,
                  resize: "vertical",
                }}
              />
            </div>
            <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                color: "#334155",
                fontWeight: 700,
                fontSize: 13,
              }}
            >
              <input
                type={"checkbox"}
                checked={!!moduloEditando.minimizado}
                onChange={(event) =>
                  setModuloEditando((prev) => ({
                    ...prev,
                    minimizado: event.target.checked,
                  }))
                }
              />
              {"Iniciar recolhido"}
            </label>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 10,
              marginTop: 16,
            }}
          >
            <button onClick={() => setModuloEditando(null)} style={BTN_GHOST}>
              {"Cancelar"}
            </button>
            <button
              onClick={async () => {
                if (moduloEditando.nome.trim()) {
                  try {
                    if (updateConteudoModulo) {
                      await updateConteudoModulo(moduloEditando.id, {
                        nome: moduloEditando.nome.trim(),
                        descricao: (moduloEditando.descricao || "").trim(),
                        minimizado: !!moduloEditando.minimizado,
                      });
                    } else {
                      setConteudos((prev) => ({
                        ...prev,
                        modulos: prev.modulos.map((item) =>
                          item.id === moduloEditando.id
                            ? {
                                ...item,
                                nome: moduloEditando.nome.trim(),
                                descricao: (
                                  moduloEditando.descricao || ""
                                ).trim(),
                                minimizado: !!moduloEditando.minimizado,
                              }
                            : item,
                        ),
                      }));
                    }
                  } catch (error) {
                    showFlash("Erro ao atualizar modulo na API.", "er");
                    return;
                  }
                  setModuloEditando(null);
                  showFlash("Modulo atualizado.");
                } else showFlash("Nome do modulo obrigatorio.", "er");
              }}
              style={BTN_PRIMARY}
            >
              {"Salvar"}
            </button>
          </div>
        </Modal>
      )}
      {novaAulaOpen && (
        <Modal titulo={"Nova aula"} onClose={() => setNovaAulaOpen(false)}>
          <div
            style={{
              display: "grid",
              gap: 12,
            }}
          >
            <div>
              <label style={LABEL}>{"Título"}</label>
              <input
                value={aulaForm.titulo}
                onChange={(event) =>
                  setAulaForm((prev) => ({
                    ...prev,
                    titulo: event.target.value,
                  }))
                }
                style={INPUT}
              />
            </div>
            <div>
              <label style={LABEL}>{"Módulo"}</label>
              <select
                value={aulaForm.modulo_id}
                onChange={(event) =>
                  setAulaForm((prev) => ({
                    ...prev,
                    modulo_id: event.target.value,
                  }))
                }
                style={INPUT}
              >
                <option value={""}>{"Selecione"}</option>
                {modulos.map((modulo) => (
                  <option value={modulo.id} key={modulo.id}>
                    {modulo.nome}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label style={LABEL}>{"URL do video"}</label>
              <input
                value={aulaForm.videoUrl}
                onChange={(event) =>
                  setAulaForm((prev) => ({
                    ...prev,
                    videoUrl: event.target.value,
                  }))
                }
                style={INPUT}
              />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 10,
              marginTop: 16,
            }}
          >
            <button onClick={() => setNovaAulaOpen(false)} style={BTN_GHOST}>
              {"Cancelar"}
            </button>
            <button
              onClick={async () => {
                if (aulaForm.titulo.trim() && aulaForm.modulo_id) {
                  try {
                    if (addConteudoAula) {
                      await addConteudoAula({
                        modulo_id: aulaForm.modulo_id,
                        titulo: aulaForm.titulo.trim(),
                        videoUrl: aulaForm.videoUrl.trim(),
                        guias: [
                          {
                            id: uuid(),
                            nome: "Conteudo",
                            blocos: [],
                          },
                        ],
                      });
                    } else {
                      setConteudos((prev) => ({
                        ...prev,
                        aulas: [
                          ...prev.aulas,
                          {
                            id: uuid(),
                            modulo_id: aulaForm.modulo_id,
                            titulo: aulaForm.titulo.trim(),
                            videoUrl: aulaForm.videoUrl.trim(),
                            guias: [
                              {
                                id: uuid(),
                                nome: "Conteudo",
                                blocos: [],
                              },
                            ],
                          },
                        ],
                      }));
                    }
                  } catch (error) {
                    showFlash("Erro ao criar aula na API.", "er");
                    return;
                  }
                  setNovaAulaOpen(false);
                  setAulaForm({
                    titulo: "",
                    modulo_id: modulos[0]?.id || "",
                    videoUrl: "",
                  });
                  showFlash("Aula criada.");
                } else showFlash("Titulo e modulo sao obrigatorios.", "er");
              }}
              style={BTN_PRIMARY}
            >
              {"Criar aula"}
            </button>
          </div>
        </Modal>
      )}
      {aulaEditando && (
        <Modal
          titulo={"Editar: ".concat(aulaEditando.titulo)}
          onClose={() => setAulaEditando(null)}
          maxWidth={820}
        >
          <LessonEditor
            aula={aulaEditando}
            onCancel={() => setAulaEditando(null)}
            onBlockDeleted={(blocoId) => {
              setConteudos((prev) => ({
                ...prev,
                aulas: (prev.aulas || []).map((item) =>
                  item.id === aulaEditando.id
                    ? {
                        ...item,
                        guias: (item.guias || []).map((guia) => ({
                          ...guia,
                          blocos: (guia.blocos || []).filter(
                            (itemId) => itemId.id !== blocoId,
                          ),
                        })),
                      }
                    : item,
                ),
              }));
            }}
            onSave={async (aulaAtualizada) => {
              if (aulaAtualizada.titulo.trim()) {
                try {
                  if (updateConteudoAula) {
                    await updateConteudoAula(aulaEditando.id, aulaAtualizada);
                  } else {
                    setConteudos((prev) => ({
                      ...prev,
                      aulas: prev.aulas.map((item) =>
                        item.id === aulaEditando.id ? aulaAtualizada : item,
                      ),
                    }));
                  }
                } catch (error) {
                  showFlash("Erro ao atualizar aula na API.", "er");
                  return;
                }
                setAulaEditando(null);
                showFlash("Aula atualizada.");
              } else showFlash("Titulo da aula obrigatorio.", "er");
            }}
            showFlash={showFlash}
          />
        </Modal>
      )}
      <Breadcrumb
        onHome={onVoltar}
        items={[
          {
            label: categoria?.nome || "Categoria",
            onClick: onVoltar,
          },
          {
            label: curso.nome,
          },
        ]}
      />
      <div
        style={{
          ...CARD,
          padding: 18,
          marginBottom: 14,
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: 12,
            alignItems: "start",
          }}
        >
          <div>
            <div
              style={{
                fontSize: 12,
                fontWeight: 800,
                color: "#64748B",
                marginBottom: 6,
              }}
            >
              {"Gestão de curso"}
            </div>
            <h2
              style={{
                margin: 0,
                color: "#17212B",
                fontSize: 24,
              }}
            >
              {curso.nome}
            </h2>
            {curso.descricao && (
              <p
                style={{
                  margin: "8px 0 0",
                  color: "#526273",
                  fontSize: 13,
                }}
              >
                {curso.descricao}
              </p>
            )}
          </div>
          <div
            style={{
              display: "flex",
              gap: 8,
              flexWrap: "wrap",
              justifyContent: "flex-end",
            }}
          >
            <button
              onClick={async () => {
                if (
                  window.confirm("Desativar o curso ".concat(curso.nome, "?"))
                )
                  try {
                    if (removeConteudoCurso) {
                      await removeConteudoCurso(curso.id);
                      showFlash("Curso desativado.", "in");
                      onVoltar();
                    }
                  } catch (error) {
                    showFlash("Erro ao desativar curso na API.", "er");
                  }
              }}
              style={BTN_GHOST}
            >
              {"Desativar curso"}
            </button>
            <button onClick={() => setEditCursoOpen(true)} style={BTN_GHOST}>
              {"Editar curso"}
            </button>
            <button onClick={() => setNovoModuloOpen(true)} style={BTN_GHOST}>
              {"Novo modulo"}
            </button>
            <button
              onClick={() => {
                if (modulos.length) {
                  setAulaForm((prev) => ({
                    ...prev,
                    modulo_id: prev.modulo_id || modulos[0].id,
                  }));
                  setNovaAulaOpen(true);
                } else {
                  showFlash("Crie um modulo antes de adicionar aulas.", "er");
                }
              }}
              style={BTN_PRIMARY}
            >
              {"Nova aula"}
            </button>
          </div>
        </div>
      </div>
      <div
        style={{
          display: "grid",
          gap: 12,
        }}
      >
        {loadingDetalhes && (
          <div
            style={{
              ...CARD,
              padding: 18,
              color: "#64748B",
              fontSize: 13,
            }}
          >
            {"Carregando módulos..."}
          </div>
        )}
        {!loadingDetalhes && !modulos.length && (
          <div
            style={{
              ...CARD,
              padding: 18,
              color: "#64748B",
              fontSize: 13,
            }}
          >
            {"Nenhum modulo neste curso."}
          </div>
        )}
        {modulos.map((modulo) => {
          const aulasModulo = ordenarAulas(
            (dados.aulas || []).filter((item) => item.modulo_id === modulo.id),
          );
          return (
            <div
              draggable={true}
              onDragStart={(event) => {
                event.stopPropagation();
                setModuloDragId(modulo.id);
                event.dataTransfer.effectAllowed = "move";
                event.dataTransfer.setData("text/plain", modulo.id);
              }}
              onDragOver={(event) => {
                event.preventDefault();
                event.stopPropagation();
                if (moduloDragOverId !== modulo.id) {
                  setModuloDragOverId(modulo.id);
                }
              }}
              onDrop={async (event) => {
                event.preventDefault();
                event.stopPropagation();
                if (aulaDragId) {
                  const aulaOrigemId = aulaDragId;
                  setAulaDragId(null);
                  setAulaDragOverId(null);
                  await (async (aulaOrigemIdItem, moduloDestinoId) => {
                    if (!aulaOrigemIdItem || !moduloDestinoId) return;
                    const aulaOrigem = (dados.aulas || []).find(
                      (item) => item.id === aulaOrigemIdItem,
                    );
                    if (aulaOrigem && aulaOrigem.modulo_id !== moduloDestinoId)
                      try {
                        await reorderConteudoAula({
                          sourceId: aulaOrigemIdItem,
                          targetModuloId: moduloDestinoId,
                        });
                        await recarregarDetalhesCurso();
                        showFlash("Aula movida para o novo módulo.");
                      } catch (err) {
                        showFlash("Erro ao mover a aula de módulo.", "er");
                      }
                  })(aulaOrigemId, modulo.id);
                  return;
                }
                const moduloOrigemId =
                  moduloDragId || event.dataTransfer.getData("text/plain");
                setModuloDragId(null);
                setModuloDragOverId(null);
                await reordenarModulosCurso(moduloOrigemId, modulo.id, modulos);
              }}
              onDragEnd={() => {
                setModuloDragId(null);
                setModuloDragOverId(null);
              }}
              style={{
                borderRadius: 14,
                overflow: "hidden",
                background: SURFACE,
                border: "1px solid ".concat(SURFACE_BORDER),
                opacity: moduloDragId === modulo.id ? 0.55 : 1,
                outline:
                  moduloDragOverId === modulo.id && moduloDragId !== modulo.id
                    ? "2px dashed #4FD1C5"
                    : "none",
                cursor: "grab",
                transition: "all 0.2s ease-in-out",
              }}
              key={modulo.id}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 12,
                  alignItems: "start",
                  padding: 14,
                  background: "rgba(255,255,255,.06)",
                }}
              >
                <div>
                  <div
                    style={{
                      color: "#FFF",
                      fontSize: 16,
                      fontWeight: 900,
                    }}
                  >
                    {modulo.nome}
                  </div>
                  {modulo.descricao && (
                    <div
                      style={{
                        color: "rgba(255,255,255,.56)",
                        fontSize: 12,
                        marginTop: 4,
                      }}
                    >
                      {modulo.descricao}
                    </div>
                  )}
                </div>
                <div
                  style={{
                    display: "flex",
                    gap: 8,
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 2,
                    }}
                  >
                    <button
                      title={"Mover para cima"}
                      disabled={0 === modulos.indexOf(modulo)}
                      onClick={async (event) => {
                        event.stopPropagation();
                        const idx = modulos.indexOf(modulo);
                        if (!(idx <= 0)) {
                          await reordenarModulosCurso(
                            modulo.id,
                            modulos[idx - 1].id,
                            modulos,
                          );
                        }
                      }}
                      style={{
                        ...BUTTON_RESET,
                        width: 24,
                        height: 20,
                        display: "grid",
                        placeItems: "center",
                        borderRadius: 4,
                        background: "rgba(255,255,255,.10)",
                        color: "#FFF",
                        fontSize: 10,
                        opacity: 0 === modulos.indexOf(modulo) ? 0.3 : 1,
                        cursor:
                          0 === modulos.indexOf(modulo)
                            ? "not-allowed"
                            : "pointer",
                      }}
                    >
                      {"▲"}
                    </button>
                    <button
                      title={"Mover para baixo"}
                      disabled={modulos.indexOf(modulo) === modulos.length - 1}
                      onClick={async (event) => {
                        event.stopPropagation();
                        const idx = modulos.indexOf(modulo);
                        if (!(idx >= modulos.length - 1)) {
                          await reordenarModulosCurso(
                            modulo.id,
                            modulos[idx + 1].id,
                            modulos,
                          );
                        }
                      }}
                      style={{
                        ...BUTTON_RESET,
                        width: 24,
                        height: 20,
                        display: "grid",
                        placeItems: "center",
                        borderRadius: 4,
                        background: "rgba(255,255,255,.10)",
                        color: "#FFF",
                        fontSize: 10,
                        opacity:
                          modulos.indexOf(modulo) === modulos.length - 1
                            ? 0.3
                            : 1,
                        cursor:
                          modulos.indexOf(modulo) === modulos.length - 1
                            ? "not-allowed"
                            : "pointer",
                      }}
                    >
                      {"▼"}
                    </button>
                  </div>
                  <span
                    style={{
                      color: "rgba(255,255,255,.56)",
                      fontSize: 11,
                      fontWeight: 700,
                    }}
                  >
                    {aulasModulo.length}
                    {" aula(s)"}
                  </span>
                  <button
                    onClick={() => setModuloEditando(clone(modulo))}
                    style={{
                      ...BUTTON_RESET,
                      background: "transparent",
                      color: "rgba(255,255,255,.7)",
                      fontSize: 12,
                      fontWeight: 800,
                    }}
                  >
                    {"Editar"}
                  </button>
                  <button
                    onClick={async () => {
                      if (
                        window.confirm(
                          "Desativar o modulo ".concat(
                            modulo.nome,
                            " e todas as aulas?",
                          ),
                        )
                      ) {
                        try {
                          if (removeConteudoModulo) {
                            await removeConteudoModulo(modulo.id);
                          } else {
                            setConteudos((prev) => ({
                              ...prev,
                              modulos: prev.modulos.filter(
                                (item) => item.id !== modulo.id,
                              ),
                              aulas: prev.aulas.filter(
                                (item) => item.modulo_id !== modulo.id,
                              ),
                            }));
                          }
                        } catch (error) {
                          showFlash("Erro ao desativar modulo na API.", "er");
                          return;
                        }
                        showFlash("Modulo desativado.", "in");
                      }
                    }}
                    style={{
                      ...BUTTON_RESET,
                      background: "transparent",
                      color: "rgba(255,255,255,.5)",
                      fontSize: 12,
                      fontWeight: 800,
                    }}
                  >
                    {"Desativar"}
                  </button>
                </div>
              </div>
              <div
                style={{
                  padding: 12,
                  display: "grid",
                  gap: 8,
                }}
              >
                {!aulasModulo.length && (
                  <div
                    style={{
                      color: "rgba(255,255,255,.42)",
                      fontSize: 12,
                    }}
                  >
                    {"Nenhuma aula neste módulo."}
                  </div>
                )}
                {aulasModulo.map((aula) => (
                  <div
                    draggable={true}
                    onDragStart={(event) => {
                      event.stopPropagation();
                      setAulaDragId(aula.id);
                      event.dataTransfer.effectAllowed = "move";
                      event.dataTransfer.setData("text/plain", aula.id);
                    }}
                    onDragOver={(event) => {
                      event.preventDefault();
                      event.stopPropagation();
                      if (aulaDragOverId !== aula.id) {
                        setAulaDragOverId(aula.id);
                      }
                    }}
                    onDrop={async (event) => {
                      event.preventDefault();
                      event.stopPropagation();
                      const aulaOrigemId =
                        aulaDragId || event.dataTransfer.getData("text/plain");
                      setAulaDragId(null);
                      setAulaDragOverId(null);
                      await reordenarAulasModulo(aulaOrigemId, aula.id);
                    }}
                    onDragEnd={() => {
                      setAulaDragId(null);
                      setAulaDragOverId(null);
                    }}
                    style={{
                      ...CARD,
                      padding: 14,
                      display: "flex",
                      justifyContent: "space-between",
                      gap: 12,
                      alignItems: "center",
                      opacity: aulaDragId === aula.id ? 0.55 : 1,
                      outline:
                        aulaDragOverId === aula.id && aulaDragId !== aula.id
                          ? "2px dashed #4FD1C5"
                          : "none",
                      cursor: "grab",
                      transition: "all 0.2s ease-in-out",
                    }}
                    key={aula.id}
                  >
                    <div
                      style={{
                        minWidth: 0,
                        flex: 1,
                      }}
                    >
                      <div
                        style={{
                          fontSize: 14,
                          fontWeight: 800,
                          color: "#18212B",
                        }}
                      >
                        {aula.titulo}
                      </div>
                      <div
                        style={{
                          display: "flex",
                          gap: 6,
                          flexWrap: "wrap",
                          marginTop: 8,
                        }}
                      >
                        {aula.guias.map((guia) => (
                          <span
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              padding: "3px 8px",
                              borderRadius: 999,
                              background: "#F1F5F9",
                              color: "#475569",
                              fontSize: 10,
                              fontWeight: 800,
                            }}
                            key={guia.id}
                          >
                            {getGuideDisplayName(guia.nome)}
                          </span>
                        ))}
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        gap: 8,
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                        }}
                      >
                        <button
                          title={"Mover para cima"}
                          disabled={0 === aulasModulo.indexOf(aula)}
                          onClick={async (event) => {
                            event.stopPropagation();
                            const idx = aulasModulo.indexOf(aula);
                            if (!(idx <= 0)) {
                              await reordenarAulasModulo(
                                aula.id,
                                aulasModulo[idx - 1].id,
                              );
                            }
                          }}
                          style={{
                            ...BUTTON_RESET,
                            width: 24,
                            height: 20,
                            display: "grid",
                            placeItems: "center",
                            borderRadius: 4,
                            background: "#F1F5F9",
                            color: "#64748B",
                            fontSize: 10,
                            opacity: 0 === aulasModulo.indexOf(aula) ? 0.3 : 1,
                            cursor:
                              0 === aulasModulo.indexOf(aula)
                                ? "not-allowed"
                                : "pointer",
                          }}
                        >
                          {"▲"}
                        </button>
                        <button
                          title={"Mover para baixo"}
                          disabled={
                            aulasModulo.indexOf(aula) === aulasModulo.length - 1
                          }
                          onClick={async (event) => {
                            event.stopPropagation();
                            const idx = aulasModulo.indexOf(aula);
                            if (!(idx >= aulasModulo.length - 1)) {
                              await reordenarAulasModulo(
                                aula.id,
                                aulasModulo[idx + 1].id,
                              );
                            }
                          }}
                          style={{
                            ...BUTTON_RESET,
                            width: 24,
                            height: 20,
                            display: "grid",
                            placeItems: "center",
                            borderRadius: 4,
                            background: "#F1F5F9",
                            color: "#64748B",
                            fontSize: 10,
                            opacity:
                              aulasModulo.indexOf(aula) ===
                              aulasModulo.length - 1
                                ? 0.3
                                : 1,
                            cursor:
                              aulasModulo.indexOf(aula) ===
                              aulasModulo.length - 1
                                ? "not-allowed"
                                : "pointer",
                          }}
                        >
                          {"▼"}
                        </button>
                      </div>
                      <button
                        onClick={() => setAulaEditando(clone(aula))}
                        style={BTN_GHOST}
                      >
                        {"Editar"}
                      </button>
                      <button
                        onClick={async () => {
                          if (
                            window.confirm(
                              "Desativar a aula ".concat(aula.titulo, "?"),
                            )
                          ) {
                            try {
                              if (removeConteudoAula) {
                                await removeConteudoAula(aula.id);
                              } else {
                                setConteudos((prev) => ({
                                  ...prev,
                                  aulas: prev.aulas.filter(
                                    (item) => item.id !== aula.id,
                                  ),
                                  progresso: Object.keys(
                                    prev.progresso || {},
                                  ).reduce((acc, studentKey) => {
                                    const currentProgress = {
                                      ...(prev.progresso[studentKey] || {}),
                                    };
                                    delete currentProgress[aula.id];
                                    acc[studentKey] = currentProgress;
                                    return acc;
                                  }, {}),
                                }));
                              }
                            } catch (error) {
                              showFlash("Erro ao desativar aula na API.", "er");
                              return;
                            }
                            showFlash("Aula desativada.", "in");
                          }
                        }}
                        style={BTN_GHOST}
                      >
                        {"Desativar"}
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
